import { atom } from "jotai";
import { floatingToolbarActiveButtonAtom } from "./floatingToolbarActiveButtonAtom";

export const closeSecondaryToolbarMenuSetter = atom(null, (_get, set) => {
  set(floatingToolbarActiveButtonAtom, null);
});

closeSecondaryToolbarMenuSetter.debugLabel = "closeSecondaryToolbarMenuSetter";
